/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import * as stringParser from '../../../util/string.util'
import * as dateParser from '../../../util/date.util'
import Currency from '../currency'


// let connection = null
let blinkTime = null
export default class BinaryMarket extends Component {
    _ismounted = false
    constructor(props) {
        super(props);
        this.state = {
            runner_name: "",
            book: {},
            market: {},
            infoHide: true,
            width: document.documentElement.clientWidth
        };
    }
    componentDidMount() {
        this._ismounted = true

        const socket = this.props.socket;
        if (this._ismounted) {
            this.setState({ market: this.props.market, book: !!this.props.feedBooks[this.props.market.marketId] ? this.props.feedBooks[this.props.market.marketId] : !!this.props.market.metadata && !!this.props.market.metadata.book ? this.props.market.metadata.book : {} }, () => {
                if (this.props.selected_market === this.props.market.marketId && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                    this.props.betForm("", "")
                }
            })
        }
        if (!this.props.market.metadata || !this.props.market.metadata.book || this.props.market.metadata.book.status === "CLOSED" || this.props.market.metadata.book.status === "INACTIVE") {
            return false
        }
        socket.emit('market_room', this.props.market.marketId)
        // if(this.props.subscribedMarkets.indexOf(this.props.market.marketId) === -1){
        //     this.props.updateSubscribedMarkets(this.props.market.marketId)
        // }
        let stream = ""
        socket.on("market_room", data => {
            if (stream !== data && this._ismounted) {
                stream = data
                let newBook = null
                try {
                    newBook = stringParser.deSrlz(data)
                } catch {
                    let baseData = {
                        marketId: this.props.market.marketId,
                        status: "OPEN",
                        runners: []
                    }
                    Array.prototype.forEach.call(this.state.market.runners,(rnr) => {
                        let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                        baseData.runners.push(data)
                    })
                    newBook = baseData
                }
                if (this.props.market.marketId === newBook.marketId && this._ismounted) {
                    this.props.updateBook(this.props.market.marketId, newBook)
                    let curBook = this.state.book
                    if (!curBook || !curBook.runners) {
                        this.setState({ book: newBook })
                        return false
                    }
                    Array.prototype.forEach.call(curBook.runners,(rn, i) => {
                        let nrn = newBook.runners[i]
                        if (!nrn) {
                            nrn = {}
                            nrn.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            nrn.lay = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                        }
                        if (!nrn.back || nrn.back.length === 0) {
                            newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                        }
                        Array.prototype.forEach.call(rn.back,(bk, j) => {
                            if (!!nrn.back[j]) {
                                if (bk.line !== nrn.back[j].line) {
                                    nrn.back[j].has_blink = true
                                }
                                else {
                                    nrn.back[j].has_blink = false
                                }
                            }
                        })
                        if (!nrn.lay || nrn.lay.length === 0) {
                            newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                        }
                        if (!!rn.lay && rn.lay.length > 0) {
                            Array.prototype.forEach.call(rn.lay,(ly, k) => {
                                if (!!nrn.lay[k]) {
                                    if (ly.line !== nrn.lay[k].line) {
                                        nrn.lay[k].has_blink = true
                                    }
                                    else {
                                        nrn.lay[k].has_blink = false
                                    }
                                }
                            })
                        }
                        newBook.runners[i] = nrn
                    });
                    this.setState({ book: newBook }, () => {
                        if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                            this.props.betForm("", "")
                        }
                        let self = this
                        blinkTime = setTimeout(function blink() {
                            Array.prototype.forEach.call(curBook.runners,(rn, i) => {
                                let nrn = newBook.runners[i]
                                Array.prototype.forEach.call(rn.back,(bk, j) => {
                                    if (!!nrn.back[j]) {
                                        nrn.back[j].has_blink = false
                                    }
                                })
                                Array.prototype.forEach.call(rn.lay,(ly, k) => {
                                    if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                                })
                                newBook.runners[i] = nrn
                            });
                            self.setState({ book: newBook })
                        }, 500)
                    })
                }
            }
        });
        socket.on('disconnect', () => {
            socket.emit('market_room', this.props.market.marketId)
        })
        this._ismounted = true
    }
    componentWillUnmount() {
        this._ismounted = false
        clearTimeout(blinkTime)
        // const socket = this.props.socket;
        // connection.off()
    }
    componentWillReceiveProps() {
        if (this.props.isEventUpdate) {
            this.setState({ market: this.props.market, book: {} }, () => {
                this._ismounted = true

        const socket = this.props.socket;
        if (this._ismounted) {
            this.setState({ market: this.props.market, book: !!this.props.feedBooks[this.props.market.marketId] ? this.props.feedBooks[this.props.market.marketId] : !!this.props.market.metadata && !!this.props.market.metadata.book ? this.props.market.metadata.book : {} }, () => {
                if (this.props.selected_market === this.props.market.marketId && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                    this.props.betForm("", "")
                }
            })
        }
        if (!this.props.market.metadata || !this.props.market.metadata.book || this.props.market.metadata.book.status === "CLOSED" || this.props.market.metadata.book.status === "INACTIVE") {
            return false
        }
        socket.emit('market_room', this.props.market.marketId)
        // if(this.props.subscribedMarkets.indexOf(this.props.market.marketId) === -1){
        //     this.props.updateSubscribedMarkets(this.props.market.marketId)
        // }
        let stream = ""
        socket.on("market_room", data => {
            if (stream !== data && this._ismounted) {
                stream = data
                let newBook = null
                try {
                    newBook = stringParser.deSrlz(data)
                } catch {
                    let baseData = {
                        marketId: this.props.market.marketId,
                        status: "OPEN",
                        runners: []
                    }
                    Array.prototype.forEach.call(this.state.market.runners,(rnr) => {
                        let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                        baseData.runners.push(data)
                    })
                    newBook = baseData
                }
                if (this.props.market.marketId === newBook.marketId && this._ismounted) {
                    this.props.updateBook(this.props.market.marketId, newBook)
                    let curBook = this.state.book
                    if (!curBook || !curBook.runners) {
                        this.setState({ book: newBook })
                        return false
                    }
                    Array.prototype.forEach.call(curBook.runners,(rn, i) => {
                        let nrn = newBook.runners[i]
                        if (!nrn) {
                            nrn = {}
                            nrn.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                            nrn.lay = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                        }
                        if (!nrn.back || nrn.back.length === 0) {
                            newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                        }
                        Array.prototype.forEach.call(rn.back,(bk, j) => {
                            if (!!nrn.back[j]) {
                                if (bk.line !== nrn.back[j].line) {
                                    nrn.back[j].has_blink = true
                                }
                                else {
                                    nrn.back[j].has_blink = false
                                }
                            }
                        })
                        if (!nrn.lay || nrn.lay.length === 0) {
                            newBook.back = [{ price: "NA", size: "NA" }, { price: "NA", size: "NA" }, { price: "NA", size: "NA" }]
                        }
                        if (!!rn.lay && rn.lay.length > 0) {
                            Array.prototype.forEach.call(rn.lay,(ly, k) => {
                                if (!!nrn.lay[k]) {
                                    if (ly.line !== nrn.lay[k].line) {
                                        nrn.lay[k].has_blink = true
                                    }
                                    else {
                                        nrn.lay[k].has_blink = false
                                    }
                                }
                            })
                        }
                        newBook.runners[i] = nrn
                    });
                    this.setState({ book: newBook }, () => {
                        if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                            this.props.betForm("", "")
                        }
                        let self = this
                        blinkTime = setTimeout(function blink() {
                            Array.prototype.forEach.call(curBook.runners,(rn, i) => {
                                let nrn = newBook.runners[i]
                                Array.prototype.forEach.call(rn.back,(bk, j) => {
                                    if (!!nrn.back[j]) {
                                        nrn.back[j].has_blink = false
                                    }
                                })
                                Array.prototype.forEach.call(rn.lay,(ly, k) => {
                                    if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                                })
                                newBook.runners[i] = nrn
                            });
                            self.setState({ book: newBook })
                        }, 500)
                    })
                }
            }
        });
        socket.on('disconnect', () => {
            socket.emit('market_room', this.props.market.marketId)
        })
        this._ismounted = true
            })
        }
    }
    render() {
        let market = this.props.market;
        let book = this.state.book;
        let runner_bk = !!this.state.book && this.state.book !== {} && !!this.state.book.runners && this.state.book.runners.length > 0 ? this.state.book.runners[0] : null
        let mktLineExpo = {}
        let isExpo = false
        market.expo = !!this.props.mktExpos[market.marketId] ? this.props.mktExpos[market.marketId] : {}
        let marketExpo = 0
        let expoArr = []
        !!market.expo.runnersExposure && Array.prototype.forEach.call(Object.keys(market.expo.runnersExposure),(i) => {
            // if(!!market.expo.runnersExposure[i]>-1 && !!market.expo.runnersExposure[i].sharingMe>-1){
            expoArr.push((market.expo.runnersExposure[i].sharingMe))
            mktLineExpo[i] = {}
            mktLineExpo[i].expo = ((market.expo.runnersExposure[i].sharingMe))
            // }
        })
        isExpo = expoArr.length > 0
        marketExpo = expoArr.length > 0 ? Math.min(...expoArr) : 0
        let runnerCount = 0
        if (!!book.runners && book.runners.length > 1) {
            let runnerList = book.runners.filter((rnr) => {
                return rnr.status !== "REMOVED"
            })
            runnerCount = runnerList.length
        }
        if (!!book.runners && book.runners.length > 0) {
            book.runners = book.runners.sort(function (a, b) {
                return a.selectionId - b.selectionId;
            })
        }
        let multiplayFector = market.marketCondition.volume
        return (
            <>
                {!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk &&
                    <>
                        <tr className="brblumobile d-none">
                            <td colSpan="3">
                                {/* <div className="w-100">
                                    <span className="in-play-title-m" onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]} </span>
                                    <a onClick={() => { this.setState({ infoHide: false }) }} className="dhide float-right"><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                                </div>
                                {!this.state.infoHide && <div className="mobile-show d-none" style={{ background: "#ccdddd", padding: "5px", borderRadius: "5px", position: "absolute", width: "94%", zIndex: "1" }}>
                                    <span className="d-block "> Max:<span>{market.maxBet}</span> |  Max Profit:<span>{market.marketCondition.maxProfit}</span><span onClick={() => { this.setState({ infoHide: true }) }} style={{ marginRight: 5, cursor: "pointer" }} className="float-right">X</span></span>
                                </div>} */}
                                <div className="w-100">
                                    {/* <a onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(market.marketId); }} className={this.props.pinnedEvents.indexOf(market.marketId) > -1 ? "add-pin-d select-pin-d mr-1" : "add-pin-d mr-1"} style={{ "cursor": "pointer" }} title="Add to Multi Markets"></a> */}
                                    <span className="in-play-title-m" onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]} </span>
                                    <a onClick={() => { this.setState({ infoHide: false }) }} className="dhide float-right"><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className={runnerCount > 1 ? "fancyw-50 v-align px-1" : "fancyw-50 px-1"}>
                                <div className="runningf in-play-title ">
                                    <div className='d-block'>
                                    {this.state.width > 991 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            : this.state.width >= 768 && market.marketName.length < 52 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            : this.state.width >= 575 && market.marketName.length < 45 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            : this.state.width >= 500 && market.marketName.length < 37 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            : this.state.width >= 469 && market.marketName.length < 37 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            : this.state.width >= 414 && market.marketName.length < 37 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            : this.state.width >= 390 && market.marketName.length < 35 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            : this.state.width >= 375 && market.marketName.length < 35 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            : this.state.width >= 374 && market.marketName.length < 35 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => {if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            : this.state.width >= 320 && market.marketName.length < 25 ?
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                            :
                                            // eslint-disable-next-line jsx-a11y/no-distracting-elements
                                            <marquee scrollamount="2" behavior="scroll">
                                            <span className="marketnamemobile" title={dateParser.getBinaryMarketDisplayName(market.marketName)[0]} onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }} style={{ cursor: "pointer" }}>{dateParser.getBinaryMarketDisplayName(market.marketName)[0]}<span className='float-right'>[Time: <b>{dateParser.getBinaryMarketDisplayName(market.marketName)[1]}</b>]</span></span>
                                        </marquee>}
                                    </div>
                                    <div>
                                       {!!isExpo && <Currency className={"match-odds font-weight-bold d-inline-block"} amount={marketExpo} isOnlyNumber={true} showColor={true} />}
                                        <a onClick={() => { this.setState({ infoHide: false }) }} className="dhide float-right"><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                                        {!!this.props.msgMarket && <span className="wid250fancy fancymassagedesktop"><span className="fancymassage"><i className="fa fa-envelope mr-1"></i>{this.props.msgMarket}</span></span>}
                                    </div>
                                    {!this.state.infoHide && <div className="fmass mobile-show fancymassnew" >
                                        <span className="d-block "> Max:<span>{market.marketCondition.maxBet}</span> |  Max Profit:<span>{market.marketCondition.maxProfit}</span><span onClick={() => { this.setState({ infoHide: true }) }} style={{ marginRight: 5, cursor: "pointer" }} className="float-right ml-5">X</span></span>
                                    </div>}
                                </div>
                            </td>
                            <td className="w-16">
                                {!!book.runners && book.runners.length > 0 && book.runners.map((runner_bk, i) => {
                                    let is_active = !!book && book !== {} && book.status === "OPEN"
                                    let runnerAllow = this.state.market.provider === "BETHUBS" && i > 0 ? false : true
                                    return <>
                                        {runnerAllow && runner_bk.status !== "REMOVED" &&
                                                <div className={!!book && book !== {} && book.status !== "OPEN" ? "suspended-fancy" : !!book.sportingEvent && !!book.sportingEvent === true ? "ballrunning-fancy" : ""} >
                                                    {!!runner_bk.lay && <div className={this.props.type === "line" ? "ask d-inline line-m1" : "ask d-inline"} style={!!runner_bk.lay[0] && runner_bk.lay[0].has_blink ? { background: "gold" } : null} >
                                                        <span className="ask-price">{!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk && !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 && is_active ? runner_bk.lay[0].line : ""}</span>
                                                        {market.provider === "BETFAIR" && market.bettingType === "LINE" ? <span className="ask-price-small">{!!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 ? (runner_bk.lay[0].size * multiplayFector) > 999 ? parseFloat((runner_bk.lay[0].size * multiplayFector) / 1000).toFixed(1) + "K" : (runner_bk.lay[0].size * multiplayFector).toFixed(2) : ""}</span>
                                                            : <span className="ask-price-small">{!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk && !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 && is_active ? runner_bk.lay[0].price : "0.00"}</span>
                                                        }
                                                    </div>}
                                                    {!!runner_bk.back && <div className={this.props.type === "line" ? "bid d-inline line-m1" : "bid d-inline"} style={!!runner_bk.back[0] && runner_bk.back[0].has_blink ? { background: "gold" } : null}>
                                                        <span className="bid-price">{!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk && !!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && is_active ? runner_bk.back[0].line : ""}</span>
                                                        {market.provider === "BETFAIR" && market.bettingType === "LINE" ? <span className="bid-price-small">{!!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 ? (runner_bk.back[0].size * multiplayFector) > 999 ? parseFloat((runner_bk.back[0].size * multiplayFector) / 1000).toFixed(1) + "K" : (runner_bk.back[0].size * multiplayFector).toFixed(2) : ""}</span>
                                                            : <span className="bid-price-small">{!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk && !!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && is_active ? runner_bk.back[0].price : "0.00"}</span>
                                                        }
                                                </div>}
                                                </div>}
                                        </>
                            })}</td>
                            <td className="w-16 w-16-1 mobile-hide">
                                <div className={runnerCount > 1 ? "min-max-price min-max-price-center" : "min-max-price"}>
                                    <span className="d-block">Max:<span>{market.marketCondition.maxBet >= 1000 ? parseInt(market.marketCondition.maxBet / 1000) + "K" : market.marketCondition.maxBet}</span></span>
                                    <span className="d-block ">MKT:<span>{market.marketCondition.maxProfit >= 1000 ? parseInt(market.marketCondition.maxProfit / 1000) + "K" : market.marketCondition.maxProfit}</span></span>
                                </div>
                            </td>
                        </tr>

                        {!!this.props.msgMarket && <tr className="fancymassagemobile">
                            <td colSpan="3">
                                <div className="w-100"><span className="fancymassage"><i className="fa fa-envelope mr-1"></i>{this.props.msgMarket}</span></div>
                            </td>
                        </tr>}
                    </>}
            </>
        )
    }
}
